import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BlueElement, register as blueRegister } from '@onviobr/element';
import { styles } from './document-header.css';
import { EventType } from '..';
import { closeIcon, printIcon } from '../icons';
var DocumentHeader = /*#__PURE__*/function (_BlueElement) {
  function DocumentHeader() {
    var _this;
    _classCallCheck(this, DocumentHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DocumentHeader, [].concat(args));
    _this.canPreviewDocument = false;
    _this.documentName = '';
    _this.options = void 0;
    _this.canPrint = false;
    return _this;
  }
  _inherits(DocumentHeader, _BlueElement);
  return _createClass(DocumentHeader, [{
    key: "printClick",
    value: function printClick() {
      this.dispatchEvent(new CustomEvent(EventType.Print));
    }
  }, {
    key: "closeClick",
    value: function closeClick() {
      this.dispatchEvent(new CustomEvent(EventType.Closed));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$options, _this$options2;
      return this.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<div class=\"header-title\">\n\t\t\t\t<div class=\"header-text\">", "</div>\n\t\t\t\t<div class=\"header-buttons\">\n\t\t\t\t\t", "\n\t\t\t\t\t<div class=\"header-btn-container vertical-line\">\n\t\t\t\t\t\t<button title=\"", "\"\n\t\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t\t@click=\"", "\">\n\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t"])), this.documentName, this.canPreviewDocument && this.canPrint ? this.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t<div id=\"print-icon\" class=\"header-btn-container\">\n\t\t\t\t\t\t\t\t<button title=\"", "\"\n\t\t\t\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t\t\t\t@click=\"", "\">\n\t\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</div>"])), (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.strings.printButton, this.printClick, this.html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), printIcon)) : this.html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""]))), (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.strings.closeButton, this.closeClick, this.html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), closeIcon));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'document-header';
    }
  }, {
    key: "styles",
    get: function get() {
      return styles;
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        canPreviewDocument: {
          type: Boolean
        },
        canPrint: {
          type: Boolean
        },
        documentName: {
          type: String
        },
        options: {
          type: Object
        }
      };
    }
  }]);
}(BlueElement);
export { DocumentHeader as default };
export var registerDocumentHeader = function registerDocumentHeader() {
  return blueRegister(DocumentHeader);
};
